import _isError from 'lodash/isError';

const UPLOADS_ENDPOINT = process.env.NEXT_PUBLIC_UPLOADS_ENDPOINT!;

export const isLocalUrl = (src?: string) =>
  src?.indexOf('data:') === 0 || src?.indexOf('blob:') === 0 || src?.indexOf('file:') === 0;

export const isRemoteUrl = (src?: string) =>
  !isLocalUrl(src) &&
  src?.indexOf(UPLOADS_ENDPOINT) !== 0 &&
  // todo temp. need to fix uppy url upload
  false;

export const validatedSrc = (src?: string) => typeof src === 'string' && src.trim().length !== 0;

export const throwIfError = <T>(result: Error | T) => {
  if (_isError(result)) {
    throw result;
  }
  return result;
};

const base64MimeType = (encoded: string) => {
  let result = undefined;

  let mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

  if (mime && mime.length) {
    result = mime[1];
  }

  return result;
};

export const b64toBlob = (b64Src: string) => {
  const b64Data = b64Src.split(',')[1];
  let binaryString = atob(b64Data);
  let bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const blob = new Blob([bytes.buffer], { type: base64MimeType(b64Src) });
  return blob;
};
